export const useCreatePromoCardDefaultValues = () => ({
  id: 0,
  name_kz: '',
  name_ru: '',
  name_kg: '',
  name_uz: '',
  name_en: '',
  activity_type_id: null,
  participants: [],
  reg_start_date: '',
  reg_end_date: '',
  activity_start_date: '',
  activity_end_date: '',
  bonus_start_date: '',
  bonus_end_date: '',
  description_ru: '',
  description_kg: '',
  description_uz: '',
  description_kz: '',
  description_en: '',
  image: null,
  objective_ids: [],
  created_at: '',
  updated_at: '',
  before_takepart_banner_id: null,
  after_takepart_banner_id: null,
  participant_ids: [],
  title_before_kz: '',
  title_before_ru: '',
  title_before_kg: '',
  title_before_uz: '',
  title_before_en: '',
  description_before_kz: '',
  description_before_ru: '',
  description_before_kg: '',
  description_before_uz: '',
  description_before_en: '',
});
